 
import React from "react";

import Container from "../../../../../layouts/containers/Container";
import FullregisterPatient from "../../addpatient/fullregistration/FullregisterPatient";
function General() {
  
  return (
    <Container className="aaaa">
         
         <FullregisterPatient/>
    </Container>
  );
}

export default General;
